import "../sentry";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import StreakTracker from "./streak-tracker";
import { initMixpanel, track } from "../mixpanel";
import { userId } from "./persistence/api-client";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

if (new URLSearchParams(window.location.search).has("sentry-test")) {
  throw new Error("Sentry frontend test error");
}

initMixpanel();
track("APP_OPENED", { synced: !!userId });

createRoot(rootEl).render(
  <Sentry.ErrorBoundary
    fallback={
      <p>Something went wrong. We've been notified — please try again later.</p>
    }
  >
    <StreakTracker />
  </Sentry.ErrorBoundary>,
);

new ResizeObserver(() => {
  window.parent.postMessage(
    { type: "nn-tool-resize", height: document.body.scrollHeight },
    "*",
  );
}).observe(rootEl);
